// @ts-nocheck
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Button from 'components/common/Button';
import Image from 'components/common/Image';
import { useFocusManager } from 'hooks/focus';

import { usePageNavigation } from 'hooks/pageNavigation';
import styles from './LeftNav.module.scss';

const NavItem = ({
  item,
  index,
  pageName,
  isActive,
  isFocused,
  isExpanded,
}) => {
  const history = useHistory();
  const { navigateToHome } = usePageNavigation();
  const focusManager = useFocusManager();

  let tag = null;
  let pageType = null;
  let pathname = null;
  if (item?.action === 'tag') {
    tag = item?.tag?.key;
    pageType = item?.tag?.type?.name;
    pathname = `/${pageType}/${tag}`;
  } else if (item?.action === 'home') {
    tag = item?.action;
    pageType = item?.action;
    pathname = '/home';
  } else if (item?.action === 'settings') {
    tag = item?.action;
    pageType = item?.action;
    pathname = '/settings';
  } else if (item?.action === 'leagues') {
    tag = `all-${item?.action}`;
    pathname = '/tagrow/all-leagues';
    pageType = 'tagrow';
  } else if (item?.action === 'shows') {
    tag = `all-${item?.action}`;
    pathname = '/tagrow/all-shows';
    pageType = 'tagrow';
  } else {
    tag = item?.action;
    pageType = 'tagrow';
  }
  const onClick = useCallback(() => {
    if (tag === pageName) {
      // if the active page is selected, just send focus back to content

      focusManager.setCurrentFocus(
        `${pageName.toLowerCase()}-focusable-content`,
      );
      return;
    }
    if (item?.action === 'home') {
      navigateToHome();
    } else if (tag) {
      history.push({
        pathname,
      });
    }
  }, [
    history,
    item.action,
    navigateToHome,
    pathname,
    tag,
    pageName,
    focusManager,
  ]);

  return (
    <Button
      className={classNames(isFocused && styles['has-focus'], styles.NavItem)}
      size="md"
      focusId={`left-nav-${index}`}
      onClick={onClick}
      ttsText={item.label}
    >
      <Image
        alt={item.label}
        src={isFocused || isActive ? item.image.selected : item.image.default}
        className={classNames(styles.staticImage)}
      />
      <span
        className={classNames(
          styles.text,
          isExpanded ? '' : styles['minimized-text'],
        )}
      >
        {' '}
        {item.label}
      </span>
    </Button>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  isActive: PropTypes.bool,
  isFocused: PropTypes.bool,
  isExpanded: PropTypes.bool,
  pageName: PropTypes.string,
};

NavItem.defaultProps = {
  item: null,
  index: null,
  isActive: false,
  isFocused: false,
  isExpanded: false,
  pageName: null,
};

export default NavItem;
